import { Injectable, inject } from '@angular/core';
import mixpanel from 'mixpanel-browser';

import { CapicheLoggerService } from 'capiche-logger';
import { CAPICHE_MIXPANEL_CONFIG, CapicheMixpanelConfig } from './capiche-mixpanel.config';

@Injectable({
  providedIn: 'root',
})
export class CapicheMixpanelService {
  private config = inject<CapicheMixpanelConfig>(CAPICHE_MIXPANEL_CONFIG);
  private readonly isProduction = this.config.envName === 'production';
  private readonly mixpanelToken = this.config.mixpanelToken ?? '';
  private readonly sessionPercent = this.config.sessionPercent ?? 100;
  private enabled = false;

  private logger = new CapicheLoggerService('capiche-mixpanel.service', false);

  constructor() {
    // enabled only if production OR explicitly enabled in config
    this.enabled = this.isProduction || this.config.enabled === true;

    this.logger.log(
      'constructor: isProduction:',
      this.isProduction,
      'mixpanelToken:',
      this.mixpanelToken,
      'enabled:',
      this.enabled,
      'sessionPercent:',
      this.sessionPercent,
    );

    if (this.mixpanelToken) {
      try {
        mixpanel.init(this.mixpanelToken, {
          record_sessions_percent: this.sessionPercent,
          record_mask_text_class: '',
        });
        this.logger.log('mixpanel initialized successfully');
      } catch (e) {
        this.logger.error('failed to init mixpanel:', e);
        this.enabled = false;
      }
    } else {
      this.logger.error('no mixpanel token provided – mixpanel not initialized');
      this.enabled = false;
    }
  }

  setEnabled(state: boolean) {
    if (!this.isProduction) {
      this.enabled = state;
      this.logger.log('setEnabled:', state);
    } else {
      this.logger.log('attempted to disable mixpanel in production — ignored');
    }
  }

  track(eventName: string, properties?: any) {
    if (this.enabled) {
      try {
        this.logger.log('track:', eventName, properties);
        mixpanel.track(eventName, properties);
      } catch (e) {
        this.logger.error('mixpanel.track error:', e);
      }
    } else {
      this.logger.verbose('track() skipped – mixpanel not enabled');
    }
  }

  identify(id: string) {
    if (this.enabled) {
      try {
        this.logger.log('identify:', id);
        mixpanel.identify(id);
      } catch (e) {
        this.logger.error('mixpanel.identify error:', e);
      }
    } else {
      this.logger.verbose('identify() skipped – mixpanel not enabled');
    }
  }
}
